import React, { useEffect, useRef } from 'react';
import { Box, Heading, Body, Button, Stack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';

const PartnersHero = () => {
  const videoWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoWrapperRef.current)
      videoWrapperRef.current.innerHTML = `
                    <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_glieacq2hv seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/glieacq2hv/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>
            `;
  }, []);

  return (
    <Box
      alignItems="center"
      flexDir="column"
      sx={{ contain: 'layout' }}
      mt="-97px"
      w="100%"
    >
      <Box
        w="100%"
        zIndex={-1}
        top={0}
        height="1000px"
        left={0}
        position="absolute"
      >
        <StaticImage
          loading="eager"
          objectFit="unset"
          src="../../assets/images/partners/hero/partners_hero_bg.png"
          alt=""
        />
      </Box>

      <Box
        maxW="750px"
        w="100%"
        flexDir="column"
        textAlign="center"
        mt="180px"
        alignItems="center"
      >
        <Heading size={600} color="white">
          Our Partners
        </Heading>
        <Body mb={14} size={600} color="white">
          Our network of partners are helping us transform the home improvement
          industry. These symbiotic partnerships include home improvement
          professionals, insurance carriers & carrier partners, and technology
          companies.
        </Body>
        <Button
          mb="75px"
          as={Link}
          to="https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=partners"
          size="large"
        >
          Get In Touch
        </Button>
        <Stack
          gap="50px"
          alignItems="center"
          flexDir="row"
          justifyContent="center"
          mx="auto"
        >
          <StaticImage
            objectFit="contain"
            src="../../assets/images/partners/hero/ABC_supply-whitelogo.png"
            alt="ABC Supply"
          />
          <StaticImage
            objectFit="contain"
            src="../../assets/images/partners/hero/GAF-transparent.png"
            alt="GAF"
          />
          <StaticImage
            objectFit="contain"
            src="../../assets/images/partners/hero/JH-transparent.png"
            alt="James Hardie"
          />
          <StaticImage
            objectFit="contain"
            src="../../assets/images/partners/hero/SRS-White-Logo.png"
            alt="SRS"
          />
        </Stack>
      </Box>

      <Helmet>
        <script
          src="https://fast.wistia.com/embed/medias/glieacq2hv.jsonp"
          async
        />
        <script src="https://fast.wistia.com/assets/external/E-v1.js" async />
      </Helmet>
      <Box
        mt="56px"
        d="block"
        justifyContent="center"
        maxW={{ base: '400px', tablet: '584px' }}
        mb={{ base: 12, tablet: 0 }}
        w="100%"
        borderRadius={4}
        overflow="hidden"
        ref={videoWrapperRef}
      />
    </Box>
  );
};

export default PartnersHero;
